<template>
  <wrap-container>
    <h1 class="titulo titulo--principal p32 oscuro medium">
      ¿En qué podemos ayudarte?
    </h1>
    <p id="producto">
      Elegí el producto o servicio por el que querés consultar o reclamar:
    </p>
    <wrap-container>
      <custom-select
        label="Producto"
        :items="tiposProducto"
        v-model="model.tiposProducto"
        :required="true"
        @input="changeTipoProducto"
      />
    </wrap-container>
    <wrap-container>
      <div id="mensajeAlert" v-if="esComex">
        <img
          src="@/assets/img/1x/0info_icon.png"
          height="23px"
          alt="Info icon"
        />
        <p>
          Si la consulta es referida a la compra y venta de moneda extranjera
          por favor ingresala desde el producto "Inversiones".
        </p>
      </div>
    </wrap-container>
  </wrap-container>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import CustomSelect from "@/components/core/custom/CustomSelect";

export default {
  name: "TipoProducto",
  components: {
    WrapContainer,
    CustomSelect
  },
  data() {
    return {
      esComex: false,
      model: {
        /** Valor por default viene del router */
        tipoProducto: this.$route.meta.levels
          ? this.$route.meta.levels[0]
          : null
      }
    };
  },
  mounted() {
    this.$router.push({ name: "inversiones" });
    document.getElementById("select-10").label = "inversiones";
    document.getElementById("select-10").value = "inversiones";
    const a = document.getElementsByTagName("label")[0];
    a.style.fontSize = "11px";
    a.style.top = "-10px";
  },
  computed: {
    tiposProducto() {
      let tiposProducto = [];
      for (const key in this.config.vistas) {
        // eslint-disable-next-line no-prototype-builtins
        if (this.config.vistas.hasOwnProperty(key)) {
          const element = this.config.vistas[key];
          tiposProducto.push({
            label: element.label,
            value: element.routeName
          });
        }
      }
      return tiposProducto;
    }
  },
  methods: {
    changeTipoProducto(ruta) {
      if (ruta && this.$route.name !== ruta) {
        this.$router.push({ name: ruta });
      }
      if (ruta == "comercio-exterior") {
        this.esComex = true;
      } else {
        this.esComex = false;
      }
      const a = document.getElementsByTagName("label")[0];
      a.style.fontSize = "15px";
      a.style.top = "0px";
    }
  },
  watch: {
    $route(to) {
      this.model.tipoProducto = to.meta.levels ? to.meta.levels[0] : null;
    }
  }
};
</script>

<style>
#producto {
  font-family: BentonSansBBVA-Medium, Helvetica, Arial, sans-serif;
  font-size: 15px;
  color: black;
}
#mensajeAlert {
  background-color: #d5ecff;
  padding: 10px;
  line-height: 24px;
  display: flex;
  margin-bottom: 10px;
  margin-top: 20px;
  font-family: BentonSansBBVA-Book, Helvetica, Arial, sans-serif;
  font-size: 15px;
}

#mensajeAlert img {
  margin: 1px 16px 5px 0px;
}

#mensajeAlert p {
  margin: 0px;
}
</style>
